import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Sync <html lang> with the i18n active language.
 *
 * Intentionally does NOT touch document.title — pages that want a specific
 * title use `useSeoMeta()`, others inherit the static <title> from
 * index.html. Setting the title here on every language change overrode
 * per-page useSeoMeta values on subsequent renders.
 */
export function useDocumentLang(): void {
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.lang = i18n.language;
  }, [i18n.language]);
}
